export class ResetPasswordModel {
    public newPassword: string;
    public confirmPassword: string;
}